import { Button } from "@volca/ui/components/ui/button";
import { LogoIcon } from "@volca/ui/components/ui/logo";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

interface ErrorStateProps {
  error?: string | null;
  onRetry: () => void;
}

export const ErrorState = ({ error, onRetry }: ErrorStateProps) => (
  <Stack
    align="center"
    className="m-auto min-h-screen w-full max-w-md bg-surface-raised p-8"
    gap={8}
  >
    <LogoIcon />
    <Text variant="title" render={<h1 />} className="text-center">
      Couldn't load your payout
    </Text>
    <Text className="text-center text-subtle">
      {error || "Check the link in your text message or try again."}
    </Text>
    <Button size="sm" onClick={onRetry} className="w-full">
      Try again
    </Button>
  </Stack>
);
